import "../static/Section7.css";

export default function Section7() {
  return (
    <section className="section7">
      <div className="section7container">TODO</div>
    </section>
  );
}
